import { z } from "zod";
import { UserSchema } from "./User";

export const UpdateUserRequestSchema = UserSchema.pick({
    name: true,
    email: true,
    phoneNumber: true,
    enabled: true,
    roleId: true,
})

export type UpdateUserRequest = z.infer<typeof UpdateUserRequestSchema>;